import { sendGtmEvent } from "../definitions";
import Bowser from "bowser";

export const sendLastClickPublisherEventIfEligible = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source");
  if (utmSource !== "taboola") return;
  const lastClickPublisherRegex = /^https?:\/\/[^/]+\/([^/]+)/;
  const lastClickPublisher = lastClickPublisherRegex.exec(document.referrer);
  if (lastClickPublisher?.[1]) {
    const deviceOs = getDeviceOs();
    const deviceLabel = deviceOs ? " - " + deviceOs : "";
    sendGtmEvent({
      event: "taboolaClickConversion",
      event_label: lastClickPublisher?.[1] + deviceLabel,
    });
  }
};

const getDeviceOs = () => {
  const osName = Bowser.osname.toLowerCase();

  if (osName === "android") {
    return "Android";
  } else if (osName === "ios") {
    return "iOS";
  } else {
    return "";
  }
};
